import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";

interface DeleteMerchantConfirmationDialogProps {
  isOpen: boolean;
  merchantName: string;
  handleClose: () => void;
  handleConfirm: () => void;
}

const DeleteMerchantConfirmationDialog = ({
  isOpen,
  merchantName,
  handleClose,
  handleConfirm,
}: DeleteMerchantConfirmationDialogProps) => {
  const [confirmText, setConfirmText] = useState("");
  
  const isConfirmEnabled = confirmText === merchantName;

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Delete Location</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          This action cannot be undone. This will permanently delete the location
          account "{merchantName}", all of its data, and remove all team members.
        </DialogContentText>
        <DialogContentText sx={{ mb: 2 }}>
          Please type <strong>{merchantName}</strong> to confirm.
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="Type merchant name to confirm"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button 
          onClick={handleConfirm} 
          color="error" 
          disabled={!isConfirmEnabled}
        >
          Delete Location
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMerchantConfirmationDialog; 